import { rootApi } from "../../api/rootApi";

export const branchApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchBranchList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/branch/list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    addBranch: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/branch/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateBranch: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/branch/update`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadBranchCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/branch/upload-csv`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchBranchListMutation,
  useAddBranchMutation,
  useUpdateBranchMutation,
  useUploadBranchCsvMutation,
} = branchApi;
